/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'./internal/EditableComponent',
	'react-dom',
	'react'
], function ($, View, EditableComponent, ReactDOM, React) {
	'use strict';

	class EditableDialog extends View {

		init(options = {}) {
			super.init(options);
			this.title = options.title;
			this.textContent = options.textContent;
			this.updateCallback = options.updateCallback;
		}

		render() {
			this.editableComponent = ReactDOM.render(
				<EditableComponent
					title={this.title}
					textContent={this.textContent}
					onClose={this.close.bind(this)}
					onUpdate={this.updateCallback && this._onUpdate.bind(this)}
				/>,
				this.el
			);
			this.textarea = $('.dashboardEditableDialog').find('textarea')[0];
			this.textarea.select();
		}

		_onUpdate() {
			if(this.updateCallback) {
				this.updateCallback(this.textarea.value);
			}
			this.close();
		}

		close() {
			this.el && ReactDOM.unmountComponentAtNode(this.el);
			this.$el && this.$el.remove();
			this.$el = null;
		}
	}

	return EditableDialog;
});
